import { signal } from '@preact/signals';

/**
 * Viewport tier as a signal, for the rare case where CSS alone is not enough.
 *
 * Layout is the stylesheet's job and stays there — this exists only for components whose
 * *mounting* has a cost beyond pixels. The ultrawide deck is the case in point: hiding it
 * with `display: none` still mounts its transcript panel, which fetches a transcript over
 * the network on a phone that will never show it.
 *
 * The breakpoint is duplicated from the `@media (min-width: 1440px)` block in styles.css,
 * unavoidably: media queries cannot read custom properties, so there is no token that both
 * sides could share. Keep the two in step by hand — they are the only pair.
 */
const ULTRAWIDE = '(min-width: 1440px)';
const DESKTOP = '(min-width: 1024px)';

export const isUltrawide = signal(false);
export const isDesktop = signal(false);

if (typeof matchMedia === 'function') {
  const queryUltrawide = matchMedia(ULTRAWIDE);
  isUltrawide.value = queryUltrawide.matches;
  queryUltrawide.addEventListener('change', (event) => {
    isUltrawide.value = event.matches;
  });

  const queryDesktop = matchMedia(DESKTOP);
  isDesktop.value = queryDesktop.matches;
  queryDesktop.addEventListener('change', (event) => {
    isDesktop.value = event.matches;
  });
}
